module.exports = __webpack_public_path__ + "static/media/logos.dfbeee1b.png";